import axios from 'axios'

const instance = axios.create({
  // 开发时 '' 走 vue devServer proxy；生产构建时用 .env.production 中的地址
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 10000,
  headers: {
    'ngrok-skip-browser-warning': 'true'
  }
})

// 上传专用实例 —— 无超时限制，避免大文件超时
const uploadInstance = axios.create({
  baseURL: '',
  timeout: 0, // 无超时
  headers: {
    'ngrok-skip-browser-warning': 'true'
  }
})

function addTokenInterceptor (inst) {
  inst.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    return config
  }, function (error) {
    return Promise.reject(error)
  })

  inst.interceptors.response.use(function (response) {
    return response.data
  }, function (error) {
    return Promise.reject(error)
  })
}

addTokenInterceptor(instance)
addTokenInterceptor(uploadInstance)

export default instance

// 上传专用请求方法
// 注意：不要手动设置 Content-Type，axios 会自动添加正确的
// multipart/form-data; boundary=... 边界标识
export const uploadRequest = {
  post (url, formData, options = {}) {
    const config = {}
    // options 可以是回调函数（兼容旧用法）或配置对象
    if (typeof options === 'function') {
      config.onUploadProgress = options
    } else {
      if (options.params) config.params = options.params
      if (options.onUploadProgress) config.onUploadProgress = options.onUploadProgress
    }
    return uploadInstance.post(url, formData, config)
  }
}
